import { z } from "zod";
import { environmentSchema } from "./context.js";
import { problemCodeSchema } from "./problem.js";
/** The only integration paths whose authenticated attempts are retained. */
export const integrationRequestRouteSchema = z.enum([
    "/v1/integrations/rulesets/current",
    "/v1/integrations/rules",
    "/v1/integrations/ncm-catalog",
    "/v1/integrations/calculations:batch",
    "/v1/integrations/calculations/{calculationId}",
    "/v1/integrations/tax-lookup-jobs",
    "/v1/integrations/tax-lookup-jobs/{jobId}",
    "/v1/integrations/tax-lookup-jobs/{jobId}/entries",
]);
export const integrationRequestMethodSchema = z.enum(["GET", "POST"]);
/** Client transport identifiers are searchable metadata, never credentials. */
export const integrationRequestTransportIdSchema = z
    .string()
    .min(1)
    .max(128)
    .regex(/^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$/u)
    .refine((value) => !value.toLowerCase().startsWith("bctax_"), {
    message: "Reserved API-key prefix is not allowed",
});
const boundedTransportId = z.string().min(1).max(128).nullable();
export const integrationRequestAttemptSchema = z
    .object({
    attemptId: z.string().uuid(),
    organizationId: z.string().uuid(),
    integrationId: z.string().uuid(),
    keyId: z.string().uuid(),
    environment: environmentSchema,
    requestId: boundedTransportId,
    correlationId: boundedTransportId,
    method: integrationRequestMethodSchema,
    route: integrationRequestRouteSchema,
    occurredAt: z.string().datetime(),
    durationMs: z.number().int().nonnegative().max(3_600_000),
    statusCode: z.number().int().min(100).max(599),
    problemCode: problemCodeSchema.nullable(),
    idempotencyReplayed: z.boolean(),
})
    .strict();
export const integrationRequestAttemptPageSchema = z
    .object({
    items: z.array(integrationRequestAttemptSchema),
    nextCursor: z.string().min(1).nullable(),
    hasMore: z.boolean(),
    totalEstimate: z.number().int().nonnegative(),
})
    .strict();
//# sourceMappingURL=integration-request-history.js.map